// Component modes
export enum PostDischargeModalMode {
	CREATE = "CREATE",
	READ = "READ",
}
